import { useRecoilValue } from 'recoil';
import { standaloneFlagsState } from '~/widget/state/widgetState';
import type { StandaloneFlags } from '~/widget/utils/getStandaloneFlags';

/**
 * The `bndl_wgt_single_app` / `bndl_wgt_notrack` query parameters of a standalone link, as read
 * when the page was loaded.
 */
const useStandaloneFlags = (): StandaloneFlags =>
  useRecoilValue(standaloneFlagsState);

export default useStandaloneFlags;
